import {
  showSnackbarAction,
  setOrganizationUsersList,
  setUser,
  setTeamLeadUsersList,
  setBranchLists
} from '../Redux/actions';
import { checkPhoneNumberlength, phoneValidate } from '../Values/validatorsnew';
import { createUser } from './organizations';
import { db, firestore, functions, storage } from '../Firebase';
import Firebase from 'firebase/app';
import axios from "axios";
import { url } from "../../src/Values/constants";
import axiosHandler from "./axiosHandler";


export const createMultipleUsers = async (
  data: { [key: string]: any }[],
  map: { [key: string]: string },
  organization_id: string,
  dispatcher: any,
  submit: () => void,
  created_by: string,
  setLoad: (data: boolean) => void,
  history: any,
  activeUsers: number,
  organizationUser: number,
  country: string,
  state: string
) => {
  let error = false;
  let contactList: any[] = [];
  let employeeIdsList: any[] = [];
  data.forEach((userData, index) => {
    if (map.hasOwnProperty('Mobile No.')) {
      const no = String(userData[map['Mobile No.']]);
      // userData[map['Mobile No.']] = no.substring(no.length - 10);
      userData[map['Mobile No.']] = no;
    }
    if (!map.hasOwnProperty('Name')) {
      dispatcher(showSnackbarAction('Please Select customer name', 'error'));
      error = true;
      contactList = [];
      return;
    } else if (!map.hasOwnProperty('Mobile No.')) {
      dispatcher(showSnackbarAction('Please Select contact number', 'error'));
      error = true;
      contactList = [];
      return;
    } else if (!map.hasOwnProperty('Email ID')) {
      dispatcher(showSnackbarAction('Please Select email id', 'error'));
      error = true;
      contactList = [];
      return;
    } else if (!map.hasOwnProperty('Reporting To')) {
      dispatcher(
        showSnackbarAction('Please Select contact Reporting manager', 'error')
      );
      error = true;
      contactList = [];
      return;
    } else if (!map.hasOwnProperty('Profile')) {
      dispatcher(showSnackbarAction('Please Select Profile', 'error'));
      error = true;
      contactList = [];
      return;
    } else if (!map.hasOwnProperty('Designation')) {
      dispatcher(showSnackbarAction('Please Select designation', 'error'));
      error = true;
      contactList = [];
      return;
    } else if (!map.hasOwnProperty('Team')) {
      dispatcher(showSnackbarAction('Please Select Team Name', 'error'));
      error = true;
      contactList = [];
      return;
    } else if (!map.hasOwnProperty('Branch')) {
      dispatcher(showSnackbarAction('Please Select Branch', 'error'));
      error = true;
      contactList = [];
      return;
    } else if (checkPhoneNumberlength(userData[map['Mobile No.']]).length !== 0) {
      dispatcher(
        showSnackbarAction(
          'Invalid Contact Number at row ' + userData.sno,
          'error'
        )
      );
      error = true;
      contactList = [];
      return;
    } else if (userData[map['Name']] === '') {
      dispatcher(
        showSnackbarAction(
          'Invalid Customer Name at row ' + userData.sno,
          'error'
        )
      );
      error = true;
      contactList = [];
      return;
    }
  });
  if (error === false) {
    setLoad(true);

    data.forEach((item) => {
      if (contactList.includes(item[map['Mobile No.']])) {
        dispatcher(showSnackbarAction('Repeated User At ' + item.sno, 'error'));
      } else {
        contactList.push({
          contact_no: item[map['Mobile No.']],
          sno: item.sno,
        });
      }
    });

    data.forEach((item) => {
      if (employeeIdsList.includes(item[map['Employee Id']])) {
        dispatcher(showSnackbarAction('Repeated Employee Id At ' + item.sno, 'error'));
      } else {
        employeeIdsList.push({
          employee_id: item[map['Employee Id']],
          sno: item.sno,
        });
      }
    });

    const user = await checkUserList(contactList, dispatcher,employeeIdsList,organization_id);
    if (user === true) {
      data.forEach(async (userData, index) => {
        activeUsers = activeUsers + 1;
        createUser(
          userData[map['Email ID']],
          String(userData[map['Name']]).split(' ')[0],
          String(userData[map['Name']]).split(' ')[1],
          userData[map['Team']],
          userData[map['Reporting To']],
          userData[map['Mobile No.']],
          userData[map['Designation']],
          userData[map['Branch']],
          activeUsers <= organizationUser ? 'ACTIVE' : 'INACTIVE',
          userData[map['Profile']],
          dispatcher,
          history,
          organization_id,
          created_by,
          country,
          state,
          true,
          ()=>{},
          "",
          "",
          userData[map['Employee Id']],
        );
      });
    }
  }
  setLoad(false);
  submit();
};

const checkUserList = async (contactList: any[], dispatcher: any,employeeIdsList:any[],organization_id:any) => {
  const contacts: string[] = [];
  contactList.forEach((item) => contacts.push(item.contact_no));
  const funcData = JSON.stringify({
    contact_no: contacts,
    organization_id:organization_id
  });

  const employeeIds: string[] = [];
  employeeIdsList.forEach((item) => employeeIds.push(item.employee_id));
  const funcData2 = JSON.stringify({
    employee_id: employeeIds,
    organization_id:organization_id
  });
  const result = await functions.httpsCallable('checkMultipleUser')(funcData);
  const result2 = await functions.httpsCallable('checkMultipleUser2')(funcData2);
  if (result.data !== true) {
    const contact = contactList.filter(
      (item) => item.contact_no === result.data
    );
    dispatcher(
      showSnackbarAction(
        result.data + ' User Already Exists at ' + contact[0].sno,
        'error'
      )
    );
    return false;
  }
  if (result2.data !== true) {
    const employee = employeeIdsList.filter(
      (item) => item.employee_id === result2.data
    );
    dispatcher(
      showSnackbarAction(
        result2.data + ' Employee Id Already Exists at ' + employee[0].sno,
        'error'
      )
    );
    return false;
  }
  else {
    return true;
  }
};

const sortUsers = (a: any, b: any) => {
  if (a.created_at.toDate() > b.created_at.toDate()) {
    return 1;
  } else {
    return -1;
  }
};
let uidList: any[] = [];
const createUsersList = (email: string, users: any[]) => {
  users.forEach((item: any) => {
    if (item.reporting_to === email) {
      if (!uidList.includes(item.uid)) {
        uidList.push(item.uid);
        createUsersList(item.user_email, users);
      }
    }
  });
};

export const fetchOrganizationsUsers = (
  dispatcher: any,
  organization_id: string,
  user?: any
) => {
  const subscribe = firestore
    .collection('users')
    .where('organization_id', '==', organization_id)
    .onSnapshot((users) => {
      const data: any[] = [];
      if (users) {
        users.forEach((users) => {
          data.push(users.data());
        });
        // dispatcher(setOrganizationUsersList(data.sort(sortUsers)));
        if (user) {
          if (user.profile === 'Team Lead') {
            if (data) {
              if (!uidList.includes(user.uid)) {
                uidList.push(user.uid);
              }
              createUsersList(user.user_email, data);
            }

            dispatcher(setTeamLeadUsersList(uidList));
          }
        }
      } else {
        console.log('not found');
      }
    });
  return subscribe;
};

export const updateUserStatus = (
  uid: string,
  status: string,
  setLoad: (data: boolean) => void,
  dispatcher?: any,
) => {
  if (status === 'ACTIVE') {
    firestore
      .collection('users')
      .doc(uid)
      .set(
        {
          status: status,

          activated_at: Firebase.firestore.Timestamp.now(),
        },
        { merge: true }
      )
      .then(() => {
        dispatcher(
          showSnackbarAction(
            "Selected User, Activated Successfully !!",
            'success'
          )
        );
        setLoad(false);
      })
      .catch((e) => {
        console.log('Error:', e);
        setLoad(false);
      });
  } else {
    firestore
      .collection('users')
      .doc(uid)
      .set(
        {
          status: status,
          deactivated_at: Firebase.firestore.Timestamp.now(),
        },
        { merge: true }
      )
      .then(() => {
        dispatcher(
          showSnackbarAction(
            "Selected User, Deactivated Successfully !!",
            'error'
          )
        );
        setLoad(false);
      })
      .catch((e) => {
        console.log('Error:', e);
        setLoad(false);
      });
  }
};

export const EditUserDetails = async (
  uid: string,
  user_first_name: string,
  user_last_name: string,
  contact_no: string,
  designation: string,
  profile: string,
  reporting_to: string,
  team: string,
  dispatcher: any,
  check: boolean,
  setLoad: (data: boolean) => void,
  history: any,
  reportingToProfile: any,
  branch: any,
  groupHeadName?: any,
  employee_id?: any,
  employeeIdCheck?: boolean,
  organization_id?:string,
) => {
  let start = true;
  let reportingProfile = '';
  reportingToProfile.forEach((item: any) => {
    if (item.value === reporting_to) {
      reportingProfile = item.label;
    }
  });

  if (profile === 'CEO') {
    if (reportingProfile === 'Sales' || reportingProfile === 'Team Lead') {
      dispatcher(
        showSnackbarAction('CEO Cannot Report To Lower Profiles!!', 'warning')
      );
      setLoad && setLoad(false);
    } else {
      start = false;
    }
  } else if (profile === 'Lead Manager') {
    if (
      reportingProfile === 'Sales' ||
      reportingProfile === 'Team Lead' ||
      reportingProfile === 'CEO'
    ) {
      dispatcher(
        showSnackbarAction(
          'Lead Manager Cannot Report To Lower Profiles!!',
          'warning'
        )
      );
      setLoad && setLoad(false);
    } else {
      start = false;
    }
  }else if (profile === 'Admin') {
    if (
      reportingProfile === 'Lead Manager' ||
      reportingProfile === 'Sales' ||
      reportingProfile === 'Team Lead' ||
      reportingProfile === 'CEO'
    ) {
      dispatcher(
        showSnackbarAction(
          'Admin Cannot Report To Lower Profiles!!',
          'warning'
        )
      );
      setLoad && setLoad(false);
    } else {
      start = false;
    }
  } else if (profile === 'Team Lead') {
    if (reportingProfile === 'Sales') {
      dispatcher(
        showSnackbarAction(
          'Team Lead Cannot Report To Lower Profiles',
          'warning'
        )
      );
      setLoad && setLoad(false);
    } else {
      start = false;
    }
  } else {
    start = false;
  }
  if (start === false) {
    let result: { data: any } = { data: true };
    let result2: { data: any } = { data: true };
    if (check === true) {
      const funcData = JSON.stringify({
        contact_no: contact_no,
        organization_id:organization_id
      });
      result = await functions.httpsCallable('checkUser')(funcData);
    } else {
      result.data = true;
    }

    if(employeeIdCheck === true && employee_id !== ""){
      const funcData2 = JSON.stringify({
        employee_id: employee_id,
        organization_id:organization_id
      });
      result2 = await functions.httpsCallable('checkUser2')(funcData2);
    }else {
      result2.data = true;
    }

    if (result.data === false) {
      dispatcher(
        showSnackbarAction('User Contact Number Already Exists!!', 'warning')
      );
      setLoad && setLoad(false);
    } 
    else if (result2.data === false) {
      dispatcher(
        showSnackbarAction('Employee Id Already Exists!!', 'warning')
      );
      setLoad && setLoad(false);
    }
    else {
      firestore
        .collection('users')
        .doc(uid)
        .set(
          {
            user_first_name,
            user_last_name,
            contact_no,
            designation,
            profile,
            reporting_to,
            team,
            branch,
            group_head_name:(groupHeadName === "Select" || groupHeadName === "" || !groupHeadName) ? "" : groupHeadName,
            employee_id
          },
          { merge: true }
        )
        .then(async () => {
          if(profile !== "Admin"){
            await functions.httpsCallable('changeRole')(
              JSON.stringify({ uid: uid, role: profile })
            );
          }
          dispatcher(
            showSnackbarAction(
              'Record has been updated successfully !',
              'success'
            )
          );
          setLoad(false);
          history.replace('/');
        })
        .catch((e) => {
          console.log('Error edit:', e);
          dispatcher(showSnackbarAction('Error! Try Again!!', 'error'));
          setLoad(false);
        });
    }
  }
};

// export const fetchProfilesData = (setProfile: (data: any[]) => void) => {
//   const subscriber = firestore
//     .collection('values')
//     .doc('profiles')
//     .onSnapshot((profiles) => {
//       if (profiles) {
//         setProfile(profiles.data()?.profiles);
//       } else {
//         console.log('profiles not found');
//       }
//     });
//   return subscriber;
// };

export const uploadUserImage = async (
  file: any,
  uid: string,
  deletePrev: boolean,
  dispatcher: any
) => {
  const path = `userImages/${uid}`;
  const reference = storage.ref(path);
  if (deletePrev) {
    await reference.delete();
  }
  try {
    const snapshot = await reference.put(file);
    const url = await reference.getDownloadURL();
    dispatcher(setUser({ user_image: url }));
    try {
      await firestore.collection('users').doc(uid).set(
        {
          user_image: url,
        },
        { merge: true }
      );
    } catch (error) {
      console.log('User Image Upload Error', error);
      dispatcher(showSnackbarAction('Error!!', 'error'));
    }
  } catch (error) {
    console.log('User Image Upload Error', error);
    dispatcher(showSnackbarAction('Error!!', 'error'));
  }
};

export const updateUserImport = (
  organization_id: string,
  email: string,
  importStatus: boolean,
  dispatcher: any,
  setLoad: (data: boolean) => void
) => {
  firestore
    .collection('users')
    .where('organization_id', '==', organization_id)
    .where('user_email', '==', email)
    .get()
    .then((users) => {
      users.docs.forEach((user) => {
        user.ref
          .set(
            {
              import: importStatus,
            },
            { merge: true }
          )
          .then(() => {
            console.log('Import status updated');
            dispatcher(
              showSnackbarAction('Import Properties Updated', 'success')
            );
            setLoad(false);
          })
          .catch((error) => {
            console.log('Import status error', error);
            setLoad(false);
          });
      });
    });
};

export const EditUserTableHeader = async (
  uid: string,
  type: string,
  column: string[]
) => {
  const columnName = type + 'Column';
  const set = { [`${columnName}`]: column };
  await firestore.collection('users').doc(uid).set(set, { merge: true });
};

export const setBranchPermission = async(
  uid: string,
  organization_id:any,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  branchList: any[],
  close: () => void
) => {
//   firestore
//     .collection('users')
//     .doc(uid)
//     .set(
//       {
//         branchPermission: branchList,
//       },
//       { merge: true }
//     )
//     .then(() => {
//       dispatcher(showSnackbarAction('Branch Permissions Set!!', 'success'));
//       setLoad(false);
//       close();
//     })
//     .catch((error) => {
//       console.log('Branch Permissions Set Error-', error);
//       setLoad(false);
//       close();
//     });


try {
  const apiData={
    // organization_id:organization_id,
    uid:uid,
    data:{
      branchPermission:branchList
    }
 }

 console.log("rishabhBrachList",apiData)
  const res = await axiosHandler.post(url + '/users/update', apiData);
  dispatcher(showSnackbarAction('Branch Permissions Set!!', 'success'));
  setLoad(false);
      close();
} catch (error:any) {
  console.log("error",error.message)
  setLoad(false);
      close();
}


};

export const fetchBranchList =async (
  uid: string,
  setBranchList: (data: any[]) => void
) => {
  // firestore
  //   .collection('users')
  //   .where('uid', '==', uid)
  //   .get()
  //   .then((user) => {
  //     user.docs.forEach((user) => {
  //       if (user.data().branchPermission) {
  //         setBranchList(user.data().branchPermission);
  //       } else {
  //         setBranchList([]);
  //       }
  //     });
  //   });

try {
  const res = await axiosHandler.get(url + '/users/fetchUser', {
    params: {
      // uid: uid
    }
  });
  setBranchList(res.data.data.user.branchPermission || [])
  // console.log("rishabhPermission",res.data.data.user.branchPermission)
  
  
} catch (error:any) {
  console.log("error",error.message)
  setBranchList( [])
}


};

export const DeleteRecords = async (
  uid: string,
  organization_id: string,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  close: () => void
) => {
  try {
    await db.ref(`/${organization_id}/${uid}`).remove();
    const docs = await firestore
      .collection('contacts')
      .where('uid', '==', uid)
      .get();

    docs.forEach(async (doc) => {
      await firestore.collection('tasks').doc(doc.id).delete();
      await firestore.collection('contactSearch').doc(doc.id).delete();
      await firestore.collection('contactResources').doc(doc.id).delete();
      await doc.ref.delete();

    });
    const doc = await firestore
      .collection('analytics')
      .where('uid', '==', uid)
      .get();

    doc.forEach(async (doc) => {
      try {
        await doc.ref.delete();

      } catch (error) {
        console.log('unable to delete - ', doc.id);
      }
    });

    dispatcher(showSnackbarAction('Deleted Records!!', 'success'));
    setLoad(false);
    close();
  } catch (error) {
    console.log('unable to delete');
    dispatcher(showSnackbarAction('Error!! Try Again!!', 'error'));
    setLoad(false);
    close();
  }
};

export const fetchOrganizationUsersList = (
  organization_id: any,
  setUsersList:any
) => {
  firestore
    .collection('users')
    .where('organization_id', '==', organization_id)
    .where('status','==','ACTIVE')
    .get()
    .then((user) => {
      let usersList:any = [];
      user.docs.forEach((user) => {
        usersList.push(user.data())
      });
      console.log("aman list",usersList);
      let sortedUsersList = usersList.sort((a:any, b:any) => (a.user_email > b.user_email) ? 1 : -1);
      setUsersList(sortedUsersList);
    });
};

export const fetchOrganizationTrackingUsers = async (
  organization_id: any,
  setOrganization:any
) => {
  firestore
    .collection('organizations')
    .doc(organization_id)
    .get()
    .then((org) => {
      if (org.data()?.is_live_tracking_enabled) {
        setOrganization(org.data()?.is_live_tracking_enabled);
      }
    });
};

// export const saveOrganizationTrackingLicenses = (
//   organization_id: any,
//   organizationTrackingLicenses:any,
//   dispatcher:any,
//   setLoad:any,
//   close:any
// ) => {
//   firestore
//     .collection('organizations')
//     .doc(organization_id)
//     .update({
//       "is_live_tracking_enabled":organizationTrackingLicenses
//     })
//     .then(() => {
//       dispatcher(showSnackbarAction('Tracking Licenses Updated', 'success'));
//       setLoad(false);
//       close();
//     })
//     .catch((error) => {
//       dispatcher(showSnackbarAction('Error while updating tracking licenses', 'error'));
//       setLoad(false);
//       close();
//     });
// };

export const saveOrganizationTrackingLicenses = async (
  organization_id: any,
  data: any,
  dispatcher: any,
  setLoad: any,
  close: any
) => {
  setLoad(true);
  try {
    // const response = await fetch(url + '/organizations/updateOrg', {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify({
    //     organization_id,
    //     ...data
    //   })
    // });

    // const responseData = await response.json();

    const bodydata = {
      // organization_id,
      is_live_tracking_enabled:data
    };
    const response = await axiosHandler.put(url + '/organizations/updateOrg', bodydata);
    dispatcher(showSnackbarAction('Updated successfully', 'success'));
    setLoad(false);
    close();
    window.location.reload();
  } catch (error) {
    dispatcher(showSnackbarAction('Error while updating', 'error'));
    setLoad(false);
    close();
  }
};

export const fetchOrganizationsUsersFromMongo = async (
  dispatcher: any,
  organization_id: string,
  user?: any
) => {
  try {
    let apiData: any = {
      organization_id: organization_id,
    };
    const res = await axiosHandler.get(url + '/users/fetchAll', {
      params: apiData,
    });
    let usersData = res.data.data.usersData;
    dispatcher(setOrganizationUsersList(usersData));
    let data: string[] = [];

// Extract branch values
usersData.forEach((val: { branch: string }) => {
    data.push(val.branch);
});

// Remove duplicate values
let uniqueData: string[] = Array.from(new Set(data));

// console.log("Unique Branch Data: ", uniqueData);

// Dispatch the action to update the Redux store
dispatcher(setBranchLists(uniqueData));
    if (user) {
      if (user.profile === 'Team Lead') {
        if (usersData) {
          if (!uidList.includes(user.uid)) {
            uidList.push(user.uid);
          }
          createUsersList(user.user_email, usersData);
        }

        dispatcher(setTeamLeadUsersList(uidList));
      }
    }
  } catch (error: any) {
    console.log("Fetching Users Error", error);
    setBranchLists([])
  }
};

// create user and send them generated password to login
export const createUserMongo = async (
  user_email: string,
  user_first_name: string,
  user_last_name: string,
  team: any,
  reporting_to: any,
  contact_no: any,
  designation: any,
  branch: any,
  status: string,
  profile: string,
  dispatcher: any,
  history: any,
  id: any,
  created_by: string,
  country: string,
  state: string,
  multiple: boolean,
  setLoad?: (data: boolean) => void,
  reportingToProfile?: any,
  groupHeadName?: any,
  employee_id?: any,
  authToken?: any,
  SOID?:any,
) => {
  let check = false;
  if (reportingToProfile) {
    check = true;
    let reportingProfile = "";
    reportingToProfile.forEach((item: any) => {
      if (item.value === reporting_to) {
        reportingProfile = item.label;
      }
    });

    if (profile === "CEO") {
      if (
        reportingProfile === "Sales" ||
        reportingProfile === "Team Lead"
      ) {
        dispatcher(
          showSnackbarAction(
            "CEO Cannot Report To Lower Profiles!!",
            "warning"
          )
        );
        setLoad && setLoad(false);
      } else {
        check = false;
      }
    } else if (profile === "Lead Manager") {
      if (
        reportingProfile === "Sales" ||
        reportingProfile === "Team Lead" ||
        reportingProfile === "CEO"
      ) {
        dispatcher(
          showSnackbarAction(
            "Lead Manager Cannot Report To Lower Profiles!!",
            "warning"
          )
        );
        setLoad && setLoad(false);
      } else {
        check = false;
      }
    } else if (profile === "Team Lead") {
      if (reportingProfile === "Sales") {
        dispatcher(
          showSnackbarAction(
            "Team Lead Cannot Report To Lower Profiles",
            "warning"
          )
        );
        setLoad && setLoad(false);
      } else {
        check = false;
      }
    } else {
      check = false;
    }
  }
  if (check === false) {
    try {
      let password = "";
      // if (user_first_name.length < 4) {
      //   if (user_last_name.length < 4) {
      //     password = user_first_name.toUpperCase() + user_last_name.toUpperCase() + "@" + contact_no.toString().slice(0, 4);
      //     if (password.length < 8) {
      //       password = user_email.slice(0, 8 - password.length).toUpperCase() + password;
      //     }
      //   } else {
      //     password =
      //       user_first_name.toUpperCase() +
      //       user_last_name
      //         .slice(0, 4 - user_first_name.length)
      //         .toUpperCase() +
      //       "@" +
      //       contact_no.toString().slice(0, 4);
      //   }


      // } else {
      //   password =
      //     user_first_name.slice(0, 4).toUpperCase() +
      //     "@" +
      //     contact_no.toString().slice(0, 4);
      // }

      let apiData: any = {
        contact_no: contact_no,
        created_by: created_by,
        designation: designation,
        branch: branch,
        // organization_id: id,
        profile: profile,
        reporting_to: reporting_to,
        status: status,
        team: team,
        user_email: user_email.toLowerCase(),
        user_first_name: user_first_name,
        user_last_name: user_last_name
          ? user_last_name
          : "",
        password: password,
        user_image: "",
        device_id: "",
        group_head_name: (groupHeadName === "Select" || groupHeadName === "" || !groupHeadName) ? "" : groupHeadName,
        employee_id: employee_id ? employee_id : "",
        SOID:SOID
      };
      // axios.defaults.headers.common['x-access-token'] = authToken;
      const res = await axiosHandler.post(url + '/users/createUserWithAuth', apiData);
      let user = res.data.data.user;
      const authorization = await axiosHandler.post(url + "/userAuthorization/update", {
        userUid: user.uid, UserProfile: profile, userCreation: true
      });
      dispatcher(
        showSnackbarAction(res.data.message, "success")
      );
      setLoad && setLoad(false);
      history.replace("/userManagement");
      window.location.reload();

    } catch (error: any) {
      dispatcher(
        showSnackbarAction(
          error?.response?.data?.message ? error?.response?.data?.message : "An error occured, Please try again",
          "error"
        )
      );
      setLoad && setLoad(false);
    }
  }
};

export const EditUserDetailsMongo = async (
  uid: string,
  user_first_name: string,
  user_last_name: string,
  contact_no: string,
  designation: string,
  profile: string,
  reporting_to: string,
  team: string,
  dispatcher: any,
  check: boolean,
  setLoad: (data: boolean) => void,
  history: any,
  reportingToProfile: any,
  branch: any,
  authToken: any,
  groupHeadName?: any,
  employee_id?: any,
  employeeIdCheck?: boolean,
  organization_id?: string,
) => {
  let start = true;
  let reportingProfile = '';
  reportingToProfile.forEach((item: any) => {
    if (item.value === reporting_to) {
      reportingProfile = item.label;
    }
  });

  if (profile === 'CEO') {
    if (reportingProfile === 'Sales' || reportingProfile === 'Team Lead') {
      dispatcher(
        showSnackbarAction('CEO Cannot Report To Lower Profiles!!', 'warning')
      );
      setLoad && setLoad(false);
    } else {
      start = false;
    }
  } else if (profile === 'Admin') {
    if (
      reportingProfile === 'Lead Manager' ||
      reportingProfile === 'Sales' ||
      reportingProfile === 'Team Lead' ||
      reportingProfile === 'CEO'
    ) {
      dispatcher(
        showSnackbarAction(
          'Admin Cannot Report To Lower Profiles!!',
          'warning'
        )
      );
      setLoad && setLoad(false);
    } else {
      start = false;
    }
  } else if (profile === 'Lead Manager') {
    if (
      reportingProfile === 'Sales' ||
      reportingProfile === 'Team Lead' ||
      reportingProfile === 'CEO'
    ) {
      dispatcher(
        showSnackbarAction(
          'Lead Manager Cannot Report To Lower Profiles!!',
          'warning'
        )
      );
      setLoad && setLoad(false);
    } else {
      start = false;
    }
  } else if (profile === 'Team Lead') {
    if (reportingProfile === 'Sales') {
      dispatcher(
        showSnackbarAction(
          'Team Lead Cannot Report To Lower Profiles',
          'warning'
        )
      );
      setLoad && setLoad(false);
    } else {
      start = false;
    }
  } else {
    start = false;
  }
  if (start === false) {
    try {
      let apiData: any = {
        // organization_id,
        uid,
        contact_no,
        employee_id,
        data: {
          user_first_name,
          user_last_name,
          contact_no,
          designation,
          profile,
          reporting_to,
          team,
          branch,
          group_head_name: (groupHeadName === "Select" || groupHeadName === "" || !groupHeadName) ? "" : groupHeadName,
          employee_id
        }
      };
      // axios.defaults.headers.common['x-access-token'] = authToken;
      const res = await axiosHandler.post(url + '/users/update', apiData);
      dispatcher(
        showSnackbarAction(
          res.data.message,
          'success'
        )
      );
      window.onbeforeunload = null;
      setLoad(false);
      history.replace("/userManagement");
      window.location.reload();
    } catch (error: any) {
      dispatcher(showSnackbarAction(error?.response?.data?.message ? error?.response?.data?.message : "An error occured, Please try again", 'error'));
      setLoad(false);
    }
  }
};


export const createMultipleUsersMongo = async (
  data: { [key: string]: any }[],
  map: { [key: string]: string },
  organization_id: string,
  dispatcher: any,
  submit: () => void,
  created_by: string,
  setLoad: (data: boolean) => void,
  history: any,
  activeUsers: number,
  organizationUser: number,
  country: string,
  state: string,
  SOID: string
) => {
  try {
    let error = false;
    let contactList: any[] = [];
    let employeeIdsList: any[] = [];
    let usersToImport: any[] = [];
    data.forEach((userData, index) => {
      if (map.hasOwnProperty('Mobile No.')) {
        const no = String(userData[map['Mobile No.']]);
        // userData[map['Mobile No.']] = no.substring(no.length - 10);
        userData[map['Mobile No.']] = no;
      }
      if (!map.hasOwnProperty('Name')) {
        dispatcher(showSnackbarAction('Please Select customer name', 'error'));
        error = true;
        contactList = [];
        return;
      } else if (!map.hasOwnProperty('Mobile No.')) {
        dispatcher(showSnackbarAction('Please Select contact number', 'error'));
        error = true;
        contactList = [];
        return;
      } else if (!map.hasOwnProperty('Email ID')) {
        dispatcher(showSnackbarAction('Please Select email id', 'error'));
        error = true;
        contactList = [];
        return;
      } else if (!map.hasOwnProperty('Reporting To')) {
        dispatcher(
          showSnackbarAction('Please Select contact Reporting manager', 'error')
        );
        error = true;
        contactList = [];
        return;
      } else if (!map.hasOwnProperty('Profile')) {
        dispatcher(showSnackbarAction('Please Select Profile', 'error'));
        error = true;
        contactList = [];
        return;
      } else if (!map.hasOwnProperty('Designation')) {
        dispatcher(showSnackbarAction('Please Select designation', 'error'));
        error = true;
        contactList = [];
        return;
      } else if (!map.hasOwnProperty('Team')) {
        dispatcher(showSnackbarAction('Please Select Team Name', 'error'));
        error = true;
        contactList = [];
        return;
      } else if (!map.hasOwnProperty('Branch')) {
        dispatcher(showSnackbarAction('Please Select Branch', 'error'));
        error = true;
        contactList = [];
        return;
      } else if (userData[map['Name']] === '') {
        dispatcher(
          showSnackbarAction(
            'Invalid Customer Name at row ' + userData.sno,
            'error'
          )
        );
        error = true;
        contactList = [];
        return;
      } else if (checkPhoneNumberlength(userData[map['Mobile No.']]).length !== 0) {
        dispatcher(
          showSnackbarAction(
            'Invalid Contact Number at row ' + userData.sno,
            'error'
          )
        );
        error = true;
        contactList = [];
        return;
      } else if (userData[map['Email ID']] === '') {
        dispatcher(
          showSnackbarAction(
            'Invalid Email ID at row ' + userData.sno,
            'error'
          )
        );
        error = true;
        contactList = [];
        return;
      }
      else if (userData[map['Reporting To']] === '') {
        dispatcher(
          showSnackbarAction(
            'Invalid Reporting at row ' + userData.sno,
            'error'
          )
        );
        error = true;
        contactList = [];
        return;
      } else if (userData[map['Team']] === '') {
        dispatcher(
          showSnackbarAction(
            'Invalid Team at row ' + userData.sno,
            'error'
          )
        );
        error = true;
        contactList = [];
        return;
      } else if (userData[map['Designation']] === '') {
        dispatcher(
          showSnackbarAction(
            'Invalid Designation at row ' + userData.sno,
            'error'
          )
        );
        error = true;
        contactList = [];
        return;
      }
      else if (userData[map['Profile']] === '') {
        dispatcher(
          showSnackbarAction(
            'Invalid Profile at row ' + userData.sno,
            'error'
          )
        );
        error = true;
        contactList = [];
        return;
      }
      else if (userData[map['Branch']] === '') {
        dispatcher(
          showSnackbarAction(
            'Invalid Branch at row ' + userData.sno,
            'error'
          )
        );
        error = true;
        contactList = [];
        return;
      }
    });
    if (error === false) {
      setLoad(true);

      data.forEach((item) => {
        if (contactList.includes(item[map['Mobile No.']])) {
          dispatcher(showSnackbarAction('Repeated User At ' + item.sno, 'error'));
        } else {
          contactList.push({
            contact_no: item[map['Mobile No.']],
            sno: item.sno,
          });
        }
      });

      data.forEach((item) => {
        if (employeeIdsList.includes(item[map['Employee Id']])) {
          dispatcher(showSnackbarAction('Repeated Employee Id At ' + item.sno, 'error'));
        } else {
          employeeIdsList.push({
            employee_id: item[map['Employee Id']],
            sno: item.sno,
          });
        }
      });

      // const user = await checkUserList(contactList, dispatcher,employeeIdsList,organization_id);
      // if (user === true) {
      data.forEach(async (userData, index) => {
        activeUsers = activeUsers + 1;
        // createUser(
        //   userData[map['Email ID']],
        //   String(userData[map['Name']]).split(' ')[0],
        //   String(userData[map['Name']]).split(' ')[1],
        //   userData[map['Team']],
        //   userData[map['Reporting To']],
        //   userData[map['Mobile No.']],
        //   userData[map['Designation']],
        //   userData[map['Branch']],
        //   activeUsers <= organizationUser ? 'ACTIVE' : 'INACTIVE',
        //   userData[map['Profile']],
        //   dispatcher,
        //   history,
        //   organization_id,
        //   created_by,
        //   country,
        //   state,
        //   true,
        //   ()=>{},
        //   "",
        //   "",
        //   userData[map['Employee Id']],
        // );
        let user = {
          contact_no: userData[map['Mobile No.']],
          created_by: created_by,
          designation: userData[map['Designation']],
          branch: userData[map['Branch']],
          // organization_id: organization_id,
          profile: userData[map['Profile']],
          reporting_to: userData[map['Reporting To']],
          status: activeUsers <= organizationUser ? 'ACTIVE' : 'INACTIVE',
          team: userData[map['Team']],
          user_email: userData[map['Email ID']],
          user_first_name: String(userData[map['Name']]).split(' ')[0],
          user_last_name: String(userData[map['Name']]).split(' ')[1],
          user_image: "",
          device_id: "",
          employee_id: userData[map['Employee Id']],
          SOID:SOID
        }
        usersToImport.push(user);
      });

      let apiData: any = {
        users: usersToImport
      };
      // console.log("test data",apiData)
      const res = await axiosHandler.post(url + '/users/importUsers', apiData);
      if(res.data.message==="Invalid Mobile Number. Please re-enter")
      {
        dispatcher(
          showSnackbarAction("Invalid Mobile Number", "error")
        );
        setLoad && setLoad(false);
        submit();
      }else{
      dispatcher(
        showSnackbarAction("Users Imported", "success")
      );
      setLoad && setLoad(false);
      submit();
      window.location.reload();
    }
    }
  } catch (error:any) {
    dispatcher(
      showSnackbarAction(error?.response?.data?.message ? error.response.data.message : "An error occured, try again", "error")
    );
    setLoad && setLoad(false);
    submit();
  }
}
  // setLoad(false);
  // submit();

export const updateUserStatusMongo = async (
  uid: string,
  status: string,
  setLoad: (data: boolean) => void,
  organization_id: string,
  dispatcher?: any,
) => {
  try {
    if (status === 'ACTIVE') {
      let apiData: any = {
        // organization_id,
        uid,
        data: {
          status,
          activated_at: new Date()
        }
      };
      // axios.defaults.headers.common['x-access-token'] = authToken;
      const res = await axiosHandler.post(url + '/users/update', apiData);
      dispatcher(
        showSnackbarAction(
          "Selected User, Activated Successfully !!",
          'success'
        )
      );
      setLoad(false);
      window.location.reload();
    } else {
      let apiData: any = {
        // organization_id,
        uid,
        data: {
          status,
          deactivated_at: new Date()
        }
      };
      // axios.defaults.headers.common['x-access-token'] = authToken;
      const res = await axiosHandler.post(url + '/users/update', apiData);
      dispatcher(
        showSnackbarAction(
          "Selected User, Deactivated Successfully !!",
          'error'
        )
      );
      setLoad(false);
      window.location.reload();
    }
  } catch (error) {
    dispatcher(
      showSnackbarAction(
        "An error occured, please try again",
        'error'
      )
    );
    setLoad(false);
  }
};

export const fetchOrganizationUsersListMongo = async (
  organization_id: any,
  setUsersList:any
) => {
  try{
    let apiData: any = {
      organization_id: organization_id,
    };
    const res = await axiosHandler.get(url + '/users/fetchAll', {
      params: apiData,
    });
    let usersData = res.data.data.usersData;
    let usersList:any = [];
    usersData.forEach((user:any) => {
      if(user.status == "ACTIVE"){
        usersList.push(user);
      }
    });
    // console.log("aman list",usersList);
    let sortedUsersList = usersList.sort((a:any, b:any) => (a.user_email > b.user_email) ? 1 : -1);
    setUsersList(sortedUsersList);
  }catch(error){
    console.log("error fetching live tracking users",error);
  }
};

export const fetchOrganizationTrackingUsersMongo = async (
  organization_id: any,
  setOrganization:any
) => {
  try{
    let bodyData = {
      organization_id: organization_id
    }
    const res = await axiosHandler.get('/organizations/fetchSingleOrganization', { params: bodyData });
    let organization: any = res.data.data;
    if (organization?.is_live_tracking_enabled) {
      setOrganization(organization?.is_live_tracking_enabled);
    }
  }catch(error){
    console.log("error fetching organization data",error);
  }
};


export const googleAnalytics = async (
  screen_name: any,
  user?:any
) => {
  try{
    window.dataLayer.push({
      event : "event_tracking",
      eventName: "read pro",
      eventCategory: "read pro",
      eventAction: "page load",
      eventLabel:screen_name,
      user_id:user?.uid?user.uid:"",
      mb_user_id:user?.user_oid?user.user_oid:"",
      user_type:user?.profile?user.profile:""
  })


  }catch(error){
    console.log("error",error);
  }
};

export const googleAnalyticsTabClick = async (
  screen_name: any,
  user?:any
) => {
  try{
    window.dataLayer.push({
      event : "event_tracking",
      eventName: "read pro",
      eventCategory: "read pro",
      eventAction: "tab click",
      eventLabel:screen_name,
      user_id:user?.uid?user.uid:"",
      mb_user_id:user?.user_oid?user.user_oid:"",
      user_type:user?.profile?user.profile:""
  })


  }catch(error){
    console.log("error",error);
  }
};

export const googleAnalyticsCTAClick = async (
  cta_type: any,
  screen:any,
  user?:any
) => {
  try{
    window.dataLayer.push({
      event : "event_tracking",
      eventName: "read pro",
      eventCategory: "read pro",
      eventAction: `${cta_type} clicked`,
      eventLabel:`page: ${screen}`,
      rp_user_id:user?.uid?user.uid:"",
      mb_user_id:user?.user_oid?user.user_oid:"",
      user_type:user?.profile?user.profile:""
  })


  }catch(error){
    console.log("error",error);
  }
};

export const googleAnalyticsMMBTabClick = async (
  cta_type: any,
  screen:any,
  user?:any
) => {
  try{
    window.dataLayer.push( {
      event : "event_tracking",
      eventName: "my_magic_box",
      eventCategory: "my_magic_box",
      eventAction: `page initiated`,
      eventLabel:`source page:${screen}-${cta_type}`,
      rp_user_id:user?.uid?user.uid:"",
      mb_user_id:user?.user_oid?user.user_oid:"",
      user_type:user?.profile?user.profile:""
    })


  }catch(error){
    console.log("error",error);
  }
};

export const SendOtpBeforeUpdatingUserMobile = async (
  oldMobile: string,
  mobileIsd: string,
  newMobile: string,
  dispatcher: any,
  setrfnum: any,
  setShowUserMobileUpdateOTPModal: any,
  isUserAdmin:any,
  currentUid:any,
  setIsUpdating: (data: boolean) => void,
  employee_id: string,
  uid: string,
) => {
  try {
    let apiData: any = {
      oldMobile,
      mobileIsd,
      newMobile,
      isUserAdmin,
      currentUid,
      employee_id,
      uid
    };
    // axios.defaults.headers.common['x-access-token'] = authToken;
    const res = await axiosHandler.post(url + '/users/sendOtpBeforeUpdatingMobile', apiData);
    setrfnum(res.data.data.rfnum);
    setShowUserMobileUpdateOTPModal(true);
    // console.log("response",res.data.data.rfnum);
    // dispatcher(
    //   showSnackbarAction(
    //     res.data.message,
    //     'success'
    //   )
    // );
  } catch (error: any) {
    setIsUpdating(false)
    dispatcher(showSnackbarAction(error?.response?.data?.message ? error?.response?.data?.message : "An error occured, Please try again", 'error'));
  }
};

export const VerifyOtpBeforeUpdatingUserMobile = async (
  rfnum: string,
  oldMobile: string,
  mobileIsd:string,
  oldMobileOtp:any,
  newMobile: string,
  newMobileOtp: string,
  uid: string,
  user_first_name: string,
  user_last_name: string,
  contact_no: string,
  designation: string,
  profile: string,
  reporting_to: string,
  team: string,
  dispatcher: any,
  check: boolean,
  setLoad: (data: boolean) => void,
  history: any,
  reportingToProfile: any,
  branch: any,
  authToken: any,
  setIsUpdating: (data: boolean) => void,
  groupHeadName?: any,
  employee_id?: any,
  employeeIdCheck?: boolean,
  organization_id?: string,
  isUserAdmin?:any,
  user_oid?:any, 
) => {
  let start = true;
  let reportingProfile = '';
  reportingToProfile.forEach((item: any) => {
    if (item.value === reporting_to) {
      reportingProfile = item.label;
    }
  });

 if(profile==="Admin"){
  if(!oldMobileOtp || !newMobileOtp){
    dispatcher(showSnackbarAction("Please enter valid OTP", 'error'));
    setLoad(false);
    return
  }
 }else{
  if( !newMobileOtp){
    dispatcher(showSnackbarAction("Please enter valid OTP", 'error'));
    setLoad(false);
    return
  }
 }

  if (profile === 'CEO') {
    if (reportingProfile === 'Sales' || reportingProfile === 'Team Lead') {
      dispatcher(
        showSnackbarAction('CEO Cannot Report To Lower Profiles!!', 'warning')
      );
      setLoad && setLoad(false);
    } else {
      start = false;
    }
  } else if (profile === 'Lead Manager') {
    if (
      reportingProfile === 'Sales' ||
      reportingProfile === 'Team Lead' ||
      reportingProfile === 'CEO'
    ) {
      dispatcher(
        showSnackbarAction(
          'Lead Manager Cannot Report To Lower Profiles!!',
          'warning'
        )
      );
      setLoad && setLoad(false);
    } else {
      start = false;
    }
  } else if (profile === 'Team Lead') {
    if (reportingProfile === 'Sales') {
      dispatcher(
        showSnackbarAction(
          'Team Lead Cannot Report To Lower Profiles',
          'warning'
        )
      );
      setLoad && setLoad(false);
    } else {
      start = false;
    }
  } else {
    start = false;
  }
  if (start === false) {
    try {
      let apiData: any = {
        organization_id,
        isUserAdmin,
        uid,
        rfnum,
        oldMobile,
        mobileIsd,
        oldMobileOtp,
        newMobile,
        newMobileOtp,
        user_oid,
        data: {
          user_first_name,
          user_last_name,
          contact_no,
          designation,
          profile,
          reporting_to,
          team,
          branch,
          group_head_name: (groupHeadName === "Select" || groupHeadName === "" || !groupHeadName) ? "" : groupHeadName,
          employee_id
        }
      };
      // console.log("profile",profile)
      // console.log("apiDataVerify",apiData)
      // axios.defaults.headers.common['x-access-token'] = authToken;
      const res = await axiosHandler.post(url + '/users/verifyOtpAndUpdateUser', apiData);
      dispatcher(
        showSnackbarAction(
          res.data.message,
          'success'
        )
      );
      window.onbeforeunload = null;
      setLoad(false);
      history.replace("/");
      window.location.reload();
    } catch (error: any) {
      dispatcher(showSnackbarAction(error?.response?.data?.message ? error?.response?.data?.message : "An error occured, Please try again", 'error'));
     setIsUpdating(false)
      setLoad(false);
    }
  }
};

const getTabFromPath = () => {
  const fullPath = window.location.pathname; // e.g., '/userManagement'

  // Map of paths to event labels
  const pathToEventLabel:any = {
    "/userManagement": "Users_Tab",
    "/apis": "API_Tokens_Tab",
    "/news": "Admin_News_Tab",
    "/organsationSettting": "Admin_Settings_Tab",
    "/analytics": "Analytics_Tab",
    "/contacts": "Contacts_Tab",
    "/response": "Response_Tab",
    "/marketing": "Marketing_Tab",
    "/tasks": "Tasks_Tab",
    "/booking": "Booking_Tab",
    "/projects": "Listings_Tab",
    "/resources": "Resources_Tab",
    "/subscriptionDetails": "Subscription_Tab",
    "/Settings": "Settings_Tab",
    "/callLogs": "CallLog_Tab",
    "/faqs": "FAQ_Tab",
    "/apiData": "API_Leads_Tab",
    "/integrations": "Integrations_Tab",
    "/leadDistributor": "Lead_Distribution_Tab",
    "/auditLogs": "Audit_Logs_Tab",
    "/help": "Help_Tab",
    "/whatsappRechargePlans": "Subscription_Whatsapp_Tab"
  };

  // Return the event label or an empty string if not found
  return pathToEventLabel[fullPath] || "";
};


export const pushToGA = async (
  event: string,
  eventName: string,
  eventCategory: string,
  eventAction: string,
  user?: any,
  eventLabel?: string,
) => {
  try {
    // Get the full URL from window.location
    let event_label = eventLabel ? eventLabel : getTabFromPath();
    window.dataLayer.push({
      event: event,
      eventName: eventName,
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: event_label,
      user_id: user?.uid ? user.uid : "",
      mb_user_id: user?.user_oid ? user.user_oid : "",
      user_type: user?.profile ? user.profile : ""
    })
  } catch (error) {
    console.log("error", error);
  }
};

export const isUsingReadproApp = async (
  oid: string,
) => {
  try {
    let params: any = {
      user_oid:oid
    };
    const res = await axiosHandler.get(
      "users/isUserUsingReadproApp",
      {
        params,
      }
    );
    let isUsingReadproApp = res.data.data.isUsingReadproApp;
    return isUsingReadproApp;
  } catch (error: any) {
    return false;
  }
};

export const checkOidExist = async (
  setLoad:any
) => {
  try {
   setLoad && setLoad(true)
    const res = await axiosHandler.get(
      "users/checkOidExistInAllUsers"
    );
    setLoad && setLoad(false)
    let isUsingReadproApp = res.data.allUserOidExists;
    return isUsingReadproApp;
  } catch (error: any) {
    setLoad && setLoad(false)
    return null;
  }
};


export const syncOid = async (
  setLoad:any,
  dispatcher:any
) => {
  try {
   setLoad(true)
    const res:any = await axiosHandler.post(
      "users/syncOid"
    );
    setLoad(false)
    dispatcher(
              showSnackbarAction(
                "synced oid successfully",
                "success"
              )
            )
    window.location.reload()
    return res.message
  } catch (error: any) {
    setLoad(false)
    dispatcher(
      showSnackbarAction(
        "error while syncing the oid",
        "error"
      )
    )
    window.location.reload()
    return null;
  }
};

export const fetchAgentDetailsFromMB = async (
  setAgentDetailsMB: any,
  user_oid: string
) => {
  try {
    const res = await axiosHandler.get(url + '/users/fetchAgentDetailsFromMB', {
      params: { user_oid }
    });
    setAgentDetailsMB(res.data.data || {});
  } catch (error: any) {
    setAgentDetailsMB({});
  }
};